import moment from "moment";

import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import {
  Button,
  Chip,
  Paper,
  TableContainer,
  TableSortLabel,
  Tooltip,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import conf from "../../conf";
import EmptyTableRow from "../utils/Empty";
import {
  Organization,
  TermsConfig,
  useConfgOrganizationDownloadTerms,
} from "../../hooks/confg/base";

type TermsProps = { terms: TermsConfig };

const TermsRow = (props: TermsProps) => {
  const { hash, version, current, updatedAt } = props.terms;

  const download = useConfgOrganizationDownloadTerms();

  const handleDownload = () => download.mutate({ hash });

  return (
    <TableRow sx={conf.STYLE.LAST_CHILD_NO_BORDER}>
      <TableCell component="th" scope="row">
        <Chip size="small" label={version} />
      </TableCell>

      <TableCell align="right">{hash}</TableCell>

      <TableCell align="right">
        <Chip
          size="small"
          variant="outlined"
          label={current ? "active" : "inactive"}
          color={current ? "success" : "error"}
        />
      </TableCell>

      <TableCell align="right">{moment(updatedAt).fromNow()}</TableCell>

      <TableCell align="right">
        <Button size="small" onClick={handleDownload}>
          Download
        </Button>
      </TableCell>
    </TableRow>
  );
};

type CustomTermsHistoryProps = {
  organization: Organization;
};

const CustomTermsHistory = (props: CustomTermsHistoryProps) => {
  const organization = props.organization;

  return (
    <Paper elevation={3}>
      <TableContainer sx={{ maxHeight: 630 }}>
        <Table aria-label="collapsible table" stickyHeader>
          <TableHead>
            <TableRow>
              {conf.COLUMNS.TERMS.map((column) => (
                <TableCell
                  key={column.key}
                  align={column.isHeader ? "left" : "right"}
                >
                  <TableSortLabel>
                    {column.description ? (
                      <Tooltip title={column.description} placement="top">
                        <b>{column.label}</b>
                      </Tooltip>
                    ) : (
                      <b>{column.label}</b>
                    )}
                  </TableSortLabel>
                </TableCell>
              ))}

              <TableCell align={"right"}>
                <FileDownloadIcon fontSize="inherit" />
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {organization?.terms?.length === 0 ? (
              <EmptyTableRow type="terms & conditions" colSpan={5} />
            ) : (
              organization?.terms?.map((terms) => (
                <TermsRow key={terms.hash} terms={terms} />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default CustomTermsHistory;
